<script setup lang="ts">
import { OAuthStudypages } from '@/components';
</script>

<template>
    <div class="oauth-container">
        <OAuthStudypages />
    </div>
</template>

<style scoped lang="scss">
.oauth-container {
    height: 100vh;
    background-color: #f5f7fa;
}
</style>
